import React from "react";
import Top from "../../components/common/TopBack/index";
import { Button, Layout, Popconfirm, message } from "antd";
import "./index.scss";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import UploadImg from "./components/UploadImg";
import { listFilesByType, deleteFile } from "../../utils/api";
import { CloseCircleOutlined } from "@ant-design/icons";
const { Header, Content } = Layout;
class imgManage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadVisible: false,
      uploadType: "",
      imgList: [],
      total: 0,
    };
  }

  componentDidMount() {
    this.getPages();
  }
  getPages = async () => {
    let opt = {};
    opt.type = 1;
    opt.current = 1;
    opt.pageSize = 20;
    let data = await listFilesByType(opt);
    if (data?.code == 0) {
      this.setState({
        imgList: data?.data?.pageContent,
        total: data?.data?.current,
      });
    }
  };
  uploadModalVisible = (type) => {
    this.setState({
      uploadVisible: true,
      uploadType: type,
    });
  };
  deletes = async (e) => {
    let opt = {};
    opt.id = e.id;
    let data = await deleteFile(opt);
    if (data?.code == 0) {
      message.success("操作成功");
      this.getPages();
    } else {
      message(data?.message);
    }
  };
  render() {
    const { uploadVisible, uploadType, imgList, total } = this.state;
    return (
      <Layout>
        <Top />
        <div className="imgManage">
          <div className="col-lg-1"></div>
          <div className="col-lg-10">
            <div className="imgManage_c imgManage_heard">
              <Button
                onClick={() => this.uploadModalVisible("新建")}
                style={{ background: "#0093D8", color: "#fff", float: "right" }}
              >
                新建图片
              </Button>
              <div style={{ clear: "both" }}></div>
            </div>
            <ul className="imgManage_c imgManage_con">
              {imgList.map((item, index) => {
                return (
                  <li key={index}>
                    <img
                      onClick={() => {
                        window.open(item.content + "?download=0");
                      }}
                      src={item.content}
                    />
                    <div className="imgManage_con_bom">
                      <div>{item.name}</div>
                      <div>
                        {item.pictureOrder}/{total}
                      </div>
                    </div>
                    <div className="imgManage_con_top">
                      <Popconfirm
                        title="确认删除？"
                        onConfirm={()=>this.deletes(item)}
                        okText="确认"
                        cancelText="取消"
                      >
                        <CloseCircleOutlined style={{ fontSize: "24px",color:'#0093D8' }} />
                      </Popconfirm>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="col-lg-1"></div>
        </div>
        <UploadImg
          userLoginInfo={this.props.userLoginInfo}
          uploadVisible={uploadVisible}
          uploadType={uploadType}
          handleCancel={() => {
            this.setState({
              uploadVisible: false,
            });
            this.getPages();
          }}
        />
      </Layout>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    userLoginInfo: state.userLoginInfo,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    saveLoginInfo: (...args) => dispatch(actionWays.saveLoginInfo(...args)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(imgManage));
